var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3844 4.90873L11.5913 2.11623C11.3568 1.88189 11.039 1.75024 10.7075 1.75024C10.376 1.75024 10.0582 1.88189 9.82375 2.11623L2.11625 9.8231C1.99978 9.93886 1.90744 10.0766 1.84457 10.2283C1.7817 10.38 1.74956 10.5426 1.75 10.7069V13.5C1.75 13.8315 1.8817 14.1494 2.11612 14.3839C2.35054 14.6183 2.66848 14.75 3 14.75H13.5C13.6989 14.75 13.8897 14.671 14.0303 14.5303C14.171 14.3897 14.25 14.1989 14.25 14C14.25 13.8011 14.171 13.6103 14.0303 13.4696C13.8897 13.329 13.6989 13.25 13.5 13.25H7.8125L14.3844 6.67685C14.5005 6.56077 14.5926 6.42295 14.6555 6.27126C14.7183 6.11957 14.7507 5.95698 14.7507 5.79279C14.7507 5.62859 14.7183 5.46601 14.6555 5.31432C14.5926 5.16263 14.5005 5.02481 14.3844 4.90873ZM5.6875 13.25H3.25V10.8125L8.5 5.56248L10.9375 7.99998L5.6875 13.25ZM12 6.93748L9.5625 4.49998L10.7088 3.35373L13.1463 5.79123L12 6.93748Z",
    fill: "#004A99"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.486feaadfa163ecac013e8d68c907a20.svg";
export { ForwardRef as ReactComponent };